package com.downdogapp.client.singleton

import com.downdogapp.*
import com.downdogapp.client.api.TrackerActivityType

actual object Trackers {

  actual val isAppleHealthAvailable: Boolean get() = false
  actual val hasAppleHealthPermissions: Boolean get() = false
  actual fun recordPractice(name: String, activityType: TrackerActivityType?, startTime: Duration, duration: Duration) {}
  actual fun requestAppleHealthPermissions(completion: (Boolean) -> Unit) {}
}
